<template>
  <div class="shipments-page">
    <div class="vx-row">
      <div class="vx-col">
        <div class="page-title p-2 mb-6">
          <div class="vx-col w-full flex items-center data-list-btn-container">
            <div :style="$route.query.tab === tab ? 'background: #1C5BFE; color: white' : ''" class="relative vx-row m-2 py-2 pl-4 pr-5 cursor-pointer d-theme-dark-bg rounded-md hover:shadow-drop"
              v-for="tab in tabs" :key="tab.index" @click="changeTabFilter(tab)">
              <div class="text-sm capitalize">{{$t(tab)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <table-filter :filters="filters" :statusFilters="activeTab == 0 ? orderStatusFilters : returnStatusFilters" @changeFilter="changeFilter" @filterValue="filterValue = $event"/>
    <div class="xl:float-left clearfix xl:w-1/2 mt-4 w-full">
      <export-button class="mr-4 float-left whitespace-nowrap"></export-button>
      <print-label-button :selected="selected" class="mr-4 float-left whitespace-nowrap"></print-label-button>
    </div>
    <shipblu-table
      :sst="true" 
      v-model="selected" 
      multiple 
      orders
      @keyup.enter.native="handleSearchAllOrders" 
      @search="handleSearchAllOrders"
      search 
      :data="shipments"
      :tableLoader="tableLoader"
    >
      <template slot="thead">
        <shipblu-th>{{$t('Tracking No.')}}</shipblu-th>
        <shipblu-th>{{$t('Merchant')}}</shipblu-th>
        <shipblu-th>{{$t('Customer')}}</shipblu-th>
        <shipblu-th>{{$t('Phone Number')}}</shipblu-th>
        <shipblu-th>{{$t('Zone')}}</shipblu-th>
        <shipblu-th>{{$t('Address')}}</shipblu-th>
        <shipblu-th>{{$t('Estimated Delivery Date')}}</shipblu-th>
        <shipblu-th>{{$t('Packages')}}</shipblu-th>
        <shipblu-th>{{$t('Package Size')}}</shipblu-th>
        <shipblu-th>{{$t('Status')}}</shipblu-th>
      </template>
      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :color="`${getStyle(data[indextr])}`"
         :to="{ name: 'head-of-fleet-order-queue-view', params: { warehouseID: $route.params.warehouseID, type: data[indextr].tracking_number[0] === '2' || (data[indextr].tracking_number[0] === '3' && data[indextr].tracking_number[1] === '2') ? 'returns' : 'delivery-orders', orderID: data[indextr].id }}">
          <shipblu-td :data="data[indextr].trackingNumber" class="inactive-link">
            <p v-on:click.stop>{{ data[indextr].tracking_number }}</p>
          </shipblu-td>

          <shipblu-td :data="data[indextr].merchantName">
            {{ data[indextr].merchant.name }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].customerName">
            {{ data[indextr].customer.full_name }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].phone">
            {{ data[indextr].customer.phone }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].zone">
            {{ $t(data[indextr].customer.address.zone.name) }} / {{ $t(data[indextr].customer.address.zone.city.name) }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].loaction">
            {{ data[indextr].customer.address.line_1 }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].estimatedDate">
            {{ data[indextr].estimated_date}}
          </shipblu-td>

          <shipblu-td :data="data[indextr].packages">
            {{ data[indextr].packages.length }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].packages">
            <p v-for="packageItem in data[indextr].packages" :key="packageItem.index">
              {{packageItem.package.package_size.short_code}}
            </p>
          </shipblu-td>

          <shipblu-td :data="data[indextr].status" :style="`color: ${getStyle(data[indextr])}`" style="white-space: nowrap;">
            <template v-if="checkTooltip(data[indextr])">
              <vx-tooltip :text="data[indextr].failure_data.map(element => element.question === 'Choose reason for failed delivery'  ? new Date(element.created).toLocaleDateString('fr-CA') + '\n' + element.answer  : '').filter(element => element !== '').join('\n \n')">
                <div class="m-auto flex items-center justify-center font-semibold">
                  <div><span class="status-icon mr-1"></span></div>
                  <span class="capitalize">{{ $t(getStatusLabel(data[indextr])) }}</span>
                </div>
              </vx-tooltip>
            </template>
            <template v-else>
              <div class="m-auto flex items-center justify-center font-semibold">
                <div><span class="status-icon mr-1"></span></div>
                <span class="capitalize">{{ $t(getStatusLabel(data[indextr])) }}</span>
              </div>
            </template>
          </shipblu-td>
        </shipblu-tr>
      </template>
    </shipblu-table>
    <shipblu-pagination :maximumItems="maximumItems" :totalRows="totalRows" :currentPage="currentPage" @currentPage="currentPage = $event" @changePageSize="changePageSize" />
  </div>
</template>

<script>
import common from '@/assets/utils/common'
import {sendRequest} from '../../http/axios/requestHelper.js'
import ShipbluTable from '../../layouts/components/ShipBluTable.vue'
import ShipbluTr from '../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../layouts/components/ShipBluTd.vue'
import ExportButton from './components/ExportButton.vue'
import PrintLabelButton from './components/PrintLabelButton.vue'
import TableFilter from '../merchant/components/TableFilter.vue'
import ShipbluPagination from '../../layouts/components/ShipbluPagination.vue'

export default {
  data () {
    return {
      tabs: ['Orders', 'RTOs', 'Returns'],
      tabsDic: {'0': 'Orders', '1': 'RTOs', '2': 'Returns'},
      tabsNameDic: {'Orders': 0, 'RTOs': 1, 'Returns': 2},
      activeTab: 0,
      localStorage,
      maximumItems: localStorage.getItem('maxItems') ? Number(localStorage.getItem('maxItems')) : process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      warehousesDic: {},
      totalRows: 0,
      offset: 0,
      currentPage: (this.$route.query.page &&  Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      selected: [],
      shipments: [],
      filters: [],
      orderStatusFilters: [
        {
          name: 'All',
          value: 'all',
          color: '#1C5BFE'
        },
        {
          name: 'Created',
          value: 'created'
        },
        {
          name: 'Pickup Requested',
          value: 'pickup_requested'
        },
        {
          name: 'Out For Pickup',
          value: 'out_for_pickup'
        },
        {
          name: 'Picked Up',
          value: 'picked_up'
        },
        {
          name: 'Pickup Rescheduled',
          value: 'pickup_rescheduled'
        }
      ],
      returnStatusFilters: [
        {
          name: 'All',
          value: 'all',
          color: '#F58231'
        },
        {
          name: 'In Transit',
          value: 'in_transit'
        },
        {
          name: 'Return Rescheduled',
          value: 'return_rescheduled'
        },
        {
          name: 'Out For Return',
          value: 'out_for_return'
        },
        {
          name: 'Returned',
          value: 'returned'
        }
      ],
      searchAllOrdersVal: '',
      searchInProgress: false,
      searchedValue: ' ',
      tableLoader: false
    }
  },
  watch: {
    '$route.query.tab' () {
      this.filters = []
      this.selected = []
      this.activeTab = this.tabsNameDic[this.$route.query.tab]
      this.currentPage = 1
      this.loadDeliveryOrders()
    },
    '$route.params.warehouseID' () {
      this.searchAllOrdersVal = ''
      this.maximumItems = process.env.VUE_APP_MAXIMUM_ITEMS_TABLE
      this.currentPage = 1
      this.filters = []
      this.selected = []
      this.activeTab = this.$route.query.tab ? this.tabsNameDic[this.$route.query.tab] : '0'
      this.currentPage = 1
    },
    activeTab () {
      this.$router.push({
        query: {
          tab: this.tabsDic[this.activeTab],
          page: this.currentPage
        }
      }).catch(() => {})
    },
    currentPage () {
      this.selected = []
      this.offset = (this.currentPage - 1) * this.maximumItems
      if (this.$route.query.tab) {
        this.$router.push({
          query: {
            tab: this.$route.query.tab,
            page: this.currentPage
          }
        }).catch(() => {})
      } else {
        this.$router.push({
          query: {
            filter: this.filters,
            page: this.currentPage
          }
        }).catch(() => {})
      }
      this.loadDeliveryOrders()
    },
    selected () {
      this.$emit('selected', this.selected)
    }
  },
  methods: {
    changePageSize (val) {
      localStorage.setItem('maxItems', val)
      this.maximumItems = val
      this.currentPage = 1
      this.loadDeliveryOrders()
    },
    changeTabFilter (tab) {
      this.activeTab = this.tabsNameDic[tab]
      this.$router.push({
        query: {
          tab: this.tabsDic[this.activeTab],
          page: this.activeTab,
          filter: this.filters
        }
      }).catch(() => {})
    },
    changeFilter () {
      const filtersTemp = this.filters
      this.filters = []
      filtersTemp.forEach(item => {
        this.filters.push(item)
      })
      this.filters.includes(this.filterValue) ? this.filters.splice(this.filters.indexOf(this.filterValue), 1) : this.filters.push(this.filterValue)
      if (this.filterValue === 'all') {
        this.filters = []
      }
      this.currentPage = 1
      this.$router.push({
        query: {
          tab: this.$route.query.tab,
          filter: this.filters,
          page: this.currentPage
        }
      }).catch(() => {})
      this.loadDeliveryOrders()
    },
    handleSearchAllOrders (search) {
      this.offset = 0
      this.currentPage = 1
      this.searchAllOrdersVal = search.target && search.target !== null ? search.target.value : search
      return common.manageSearch(search, this.loadOrdersSearch)
    },
    loadOrdersSearch () {
      if (this.searchInProgress || this.searchedValue === this.searchAllOrdersVal) {
        return
      }
      this.loadDeliveryOrders()
    },
    formatWarehouses (warehouses) {
      warehouses.forEach(warehouse => {
        this.warehousesDic[warehouse.code] = warehouse.id
      })
      this.loadDeliveryOrders()
    },
    loadDeliveryOrders () {
      this.searchInProgress = true
      this.tableLoader = true
      const query = `offset=${this.offset}&limit=${this.maximumItems}&search=${this.searchAllOrdersVal}`
      const orderStatus = `&inbound_warehouse=${this.warehousesDic[this.$route.params.warehouseID]}&status=${this.filters.length > 0 ? this.filters : 'created,pickup_requested,out_for_pickup,picked_up,pickup_rescheduled'}`
      const rtoStatus = `&inbound_warehouse=${this.warehousesDic[this.$route.params.warehouseID]}&rto_requested=true&status=${this.filters.length > 0 ? this.filters : 'in_transit,out_for_return,returned,return_rescheduled'}`
      const returnStatus = `&outbound_warehouse=${this.warehousesDic[this.$route.params.warehouseID]}&status=${this.filters.length > 0 ? this.filters : 'in_transit,out_for_return,returned,return_rescheduled'}`
      sendRequest(true, false, this, `api/v1/${this.activeTab === '2' || this.activeTab === 2 ? 'returns' : 'delivery-orders'}/?${query}${this.activeTab === '0' || this.activeTab === 0 ? orderStatus : this.activeTab === '1' || this.activeTab === 1 ? rtoStatus : returnStatus}`, 'get', null, true, 
        (response) => {
          this.selected = []
          this.shipments = response.data.results
          this.tableLoader = false
          this.totalRows = response.data.count
          this.searchedValue = this.searchAllOrdersVal
        }
      )
      this.searchInProgress = false
    },
    checkTooltip (order) {
      return common.checkTooltip(order)
    },
    getStyle (data) {
      return common.getOrderStatusColor(data.status)
    },
    getOrderStatusColor (order) {
      return common.getOrderStatusColor(this.getStatusLabel(order))
    },
    getStatusLabel (order) {
      return common.getStatusLabel(order, this.$store.state.AppActiveUser.userRole)
    }
  },
  components: {
    ExportButton,
    PrintLabelButton,
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    TableFilter,
    ShipbluPagination
  },
  mounted () {
    this.$emit('setAppClasses', 'shipment-page')
  },
  created () {
    this.activeTab = this.$route.query.tab ? this.tabsNameDic[this.$route.query.tab] : '0'
    this.filters = this.$route.query.filter ? typeof (this.$route.query.filter) === 'string' ? Array(this.$route.query.filter) : this.$route.query.filter : []
    this.offset = (this.currentPage - 1) * this.maximumItems
    this.currentPage = this.$route.query.page ? Number(this.$route.query.page) : 1
    common.manageLoadWarehouses(this.formatWarehouses, this)
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
.con-pagination-table{
  display: none;
}
#order-label-print{
  display: none;
  visibility: hidden;
}
</style>